import React from 'react';
import { ToggleSwitch } from '@/components/ui/ToggleSwitch';
import styles from './styles.module.scss';

export interface SettingToggleRowProps {
  id: string;
  title: string;
  description: string;
  /** Short inline tag next to the title (e.g. "Debug only"). */
  tag?: string;
  /** Shown only while the setting is on. */
  warning?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/** Settings row: title/description on the left, switch on the right. The whole row toggles. */
export const SettingToggleRow: React.FC<SettingToggleRowProps> = ({
  id,
  title,
  description,
  tag,
  warning,
  checked,
  onChange,
  disabled,
}) => (
  <label htmlFor={id} className={styles.row}>
    <span className={styles.text}>
      <span className={styles.title}>
        {title}
        {tag && <span className={styles.tag}>{tag}</span>}
      </span>
      <span className={styles.description}>{description}</span>
      {warning && checked && (
        <span className={styles.warning} data-testid={`setting-${id}-warning`}>
          {warning}
        </span>
      )}
    </span>
    <ToggleSwitch
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      testId={`setting-${id}`}
    />
  </label>
);

export default SettingToggleRow;
